import { Navigate } from 'react-router-dom'
import { useOrganization } from '../contexts/OrganizationContext'
import LoadingSpinner from './LoadingSpinner'

const ProtectedRoute = ({ children, resource, action = 'read', requireAdmin = false }) => {
  const { organization, loading, isAdmin, canRead, canWrite, checkPermission } = useOrganization()

  if (loading) {
    return <LoadingSpinner />
  }

  // Redirect to setup page if user doesn't have an organization
  if (!organization) {
    return <Navigate to="/setup" replace />
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="section-container">
        <div className="text-center py-12">
          <p className="text-red-600 mb-4">Access denied. Admin privileges required.</p>
        </div>
      </div>
    )
  }

  if (resource) {
    const hasAccess = action === 'write' ? canWrite(resource) : canRead(resource)
    if (!hasAccess) {
      return (
        <div className="section-container">
          <div className="text-center py-12">
            <p className="text-red-600 mb-4">
              You don't have permission to {action} {resource}.
            </p>
          </div>
        </div>
      )
    }
  }

  return children
}

export default ProtectedRoute

